"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_PRESET_VIEW_MOCK = exports.UserPresetViewGroupTypes = void 0;
var types_1 = require("@bringg/types");
var UserPresetViewGroupTypes;
(function (UserPresetViewGroupTypes) {
    UserPresetViewGroupTypes["View"] = "view";
})(UserPresetViewGroupTypes = exports.UserPresetViewGroupTypes || (exports.UserPresetViewGroupTypes = {}));
exports.USER_PRESET_VIEW_MOCK = [
    {
        id: 1,
        merchant_id: 0,
        user_id: 0,
        view: types_1.PresetViewSupportedView.Dispatch,
        preset_view_id: 1
    },
    {
        id: 2,
        merchant_id: 0,
        user_id: 0,
        view: types_1.PresetViewSupportedView.Planning,
        preset_view_id: 2
    },
    {
        id: 3,
        merchant_id: 0,
        user_id: 0,
        view: types_1.PresetViewSupportedView.OrderAlerts,
        preset_view_id: 3
    },
    {
        id: 4,
        merchant_id: 0,
        user_id: 0,
        view: types_1.PresetViewSupportedView.DriverAlerts,
        preset_view_id: 4
    },
    {
        id: 5,
        merchant_id: 0,
        user_id: 0,
        view: types_1.PresetViewSupportedView.OptimisationAlerts,
        preset_view_id: 5
    }
];
//# sourceMappingURL=user-preset-views-consts.js.map